import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

/**
 *
 * @returns {"home" | "myStuff" | "login" | "signup" | "account"}
 */
const useWhatPage = () => {
  const username = useSelector((state) => state.user.username);
  const { pathname } = useLocation();

  const pageName = useMemo(() => {
    const myStuffPattern = new RegExp(`(/${username}/(sketches/?$|assets)/?)`);

    if (myStuffPattern.test(pathname)) return 'myStuff';
    else if (pathname === '/login') return 'login';
    else if (pathname === '/signup') return 'signup';
    else if (pathname === '/account') return 'account';
    return 'home';
  }, [pathname, username]);

  return pageName;
};

export default useWhatPage;
